import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appWarehouseProfilesForm]'
})
export class WarehouseProfilesFormDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/warehouse-profiles-form/warehouse-profiles-form.directive.ts